import { decimalToHex, hexToDecimal } from '../utils/numberUtils';
import { ALARM_ID_DECIMAL } from '../constants';
import { useAppSelector } from '../../reducers/rootReducer';
import { userDetailsSelectors } from '../../reducers/userDetailsSlice';

const useAlarmIdConverter = () => {
  const alarmIdRepresentation = useAppSelector(
    userDetailsSelectors.selectAlarmIdRepresentation,
  );

  return alarmIdRepresentation === ALARM_ID_DECIMAL
    ? hexToDecimal
    : decimalToHex;
};

export default useAlarmIdConverter;
